/* ==========================================================================
   NEW HEADER + TOP BAR — behaviour
   Handles: mobile hamburger drawer, keeping the cart badge in sync after
   AJAX add-to-cart, and the search widgets (desktop bar + mobile dropdown
   panel): live title-only suggestions, "Explore more", clear (x) button.
   Desktop mega menu is pure CSS (:hover / :focus-within) — no JS needed.

   v2 sidebar: same open/close API as before (nothing renamed), plus
   Escape-to-close and a scroll reset each time the drawer opens.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var toggleBtn = document.querySelector('[data-new-header-mobile-toggle]');
  var drawer = document.querySelector('[data-new-header-drawer]');
  var closeEls = document.querySelectorAll('[data-new-header-drawer-close]');
  var drawerScroll = document.querySelector('[data-new-header-drawer-scroll]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('new-header-drawer-open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    // always start the sidebar body at the top, however it was left last time
    if (drawerScroll) drawerScroll.scrollTop = 0;
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('new-header-drawer-open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', openDrawer);
  }

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  // Escape closes the drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Kept for backwards compatibility — harmless if these elements no longer
  // exist in the markup.
  document.querySelectorAll('[data-new-header-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.new-header-mobile-nav__item');
      if (!item) return;

      var wasOpen = item.classList.contains('is-open');
      var list = item.closest('.new-header-mobile-nav');

      if (list) {
        list.querySelectorAll('.new-header-mobile-nav__item.is-open').forEach(function (openItem) {
          if (openItem !== item) openItem.classList.remove('is-open');
        });
      }

      item.classList.toggle('is-open', !wasOpen);
    });
  });

  document.querySelectorAll('[data-new-header-shopping-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-new-header-shopping]');
      if (!wrap) return;
      var isOpen = wrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // Optional: if your add-to-cart JS dispatches a "cart:updated" custom
  // event with { detail: { cart } }, this keeps the new header badge in
  // sync without a page reload. Safe to leave in even if unused.
  document.addEventListener('cart:updated', function (evt) {
    var count = evt.detail && evt.detail.cart ? evt.detail.cart.item_count : null;
    if (count === null || count === undefined) return;
    document.querySelectorAll('[data-new-header-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  });

  /* ------------------------------------------------------------------ */
  /* ACTIVE NAV LINK — keep the current section highlighted             */
  /* Compares the page's current URL to every top-level nav link's href */
  /* and marks the matching one (and, for products/pages inside it,     */
  /* the closest matching parent link) with "is-active" so it stays     */
  /* green/underlined for as long as you're on that page or path.       */
  /* ------------------------------------------------------------------ */

  (function highlightActiveNavLink() {
    var navLinks = document.querySelectorAll('.new-header-nav__link');
    if (!navLinks.length) return;

    var currentPath = window.location.pathname.replace(/\/+$/, '').toLowerCase() || '/';

    var bestLink = null;
    var bestLength = -1;

    navLinks.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href === '#') return;

      var linkPath;
      try {
        linkPath = new URL(href, window.location.origin).pathname.replace(/\/+$/, '').toLowerCase();
      } catch (e) {
        return;
      }
      if (!linkPath) return;

      var matches = currentPath === linkPath || (currentPath + '/').indexOf(linkPath + '/') === 0;

      // pick the longest (most specific) matching link, in case two nav
      // items share a path prefix
      if (matches && linkPath.length > bestLength) {
        bestLink = link;
        bestLength = linkPath.length;
      }
    });

    if (bestLink) {
      bestLink.classList.add('is-active');
      var parentItem = bestLink.closest('.new-header-nav__item');
      if (parentItem) parentItem.classList.add('is-active');
    }
  })();

  /* ------------------------------------------------------------------ */
  /* SEARCH — live, title-only suggestions + clear (x) button           */
  /* ------------------------------------------------------------------ */

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var priorityHandles = [];
  var priorityHandlesEl = document.getElementById('new-header-priority-handles');
  if (priorityHandlesEl) {
    try {
      priorityHandles = JSON.parse(priorityHandlesEl.textContent) || [];
    } catch (e) {
      priorityHandles = [];
    }
  }

  function sortByPriority(products) {
    if (!priorityHandles.length) return products;

    var priority = [];
    var rest = [];

    products.forEach(function (product) {
      if (priorityHandles.indexOf(product.handle) !== -1) {
        priority.push(product);
      } else {
        rest.push(product);
      }
    });

    return priority.concat(rest);
  }

  function highlightMatch(title, term) {
    var safeTitle = escapeHtml(title);
    var safeTerm = escapeHtml(term).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (!safeTerm) return safeTitle;
    var re = new RegExp('(' + safeTerm + ')', 'ig');
    return safeTitle.replace(re, '<strong>$1</strong>');
  }

  function renderSuggestions(resultsBox, term, products, searchPageUrl) {
    resultsBox.innerHTML = '';

    if (!products.length) {
      resultsBox.innerHTML = '<p class="new-header-suggest-empty">No products found</p>';
      resultsBox.hidden = false;
      return;
    }

    var list = document.createElement('div');
    list.className = 'new-header-suggest-list';

    products.forEach(function (product) {
      var item = document.createElement('a');
      item.href = product.url;
      item.className = 'new-header-suggest-item';
      item.innerHTML =
        (product.image
          ? '<span class="new-header-suggest-item-img"><img src="' + product.image + '" alt="" loading="lazy"></span>'
          : '') +
        '<span class="new-header-suggest-item-title">' + highlightMatch(product.title, term) + '</span>';
      list.appendChild(item);
    });

    resultsBox.appendChild(list);

    var exploreLink = document.createElement('a');
    exploreLink.href = searchPageUrl + '?q=' + encodeURIComponent(term) + '&type=product&options%5Bfields%5D=title';
    exploreLink.className = 'new-header-suggest-explore';
    exploreLink.textContent = 'Explore more';
    resultsBox.appendChild(exploreLink);

    resultsBox.hidden = false;
  }

  function fetchSuggestions(term, resultsBox, searchPageUrl) {
    fetch(
      '/search/suggest.json?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6&resources[options][fields]=title'
    )
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        products = sortByPriority(products);
        renderSuggestions(resultsBox, term, products, searchPageUrl);
      })
      .catch(function () {
        resultsBox.hidden = true;
      });
  }

  function setupSearchWidget(config) {
    var form = config.form;
    var input = config.input;
    var clearBtn = config.clearBtn;
    var resultsBox = config.resultsBox;
    var toggleBtn = config.toggleBtn;
    var panel = config.panel;

    if (!form || !input || !resultsBox) return;

    var searchPageUrl = form.getAttribute('action') || '/search';
    var debounceTimer = null;

    function updateClearButton() {
      if (!clearBtn) return;
      clearBtn.hidden = input.value.length === 0;
    }

    function hideResults() {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
    }

    function runSearch() {
      var term = input.value.trim();

      window.clearTimeout(debounceTimer);

      if (term.length < 2) {
        hideResults();
        return;
      }

      debounceTimer = window.setTimeout(function () {
        fetchSuggestions(term, resultsBox, searchPageUrl);
      }, 300);
    }

    updateClearButton();

    input.addEventListener('input', function () {
      updateClearButton();
      runSearch();
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && resultsBox.hidden) {
        runSearch();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = '';
        updateClearButton();
        hideResults();
        input.focus();
      });
    }

    if (toggleBtn && panel) {
      function openPanel() {
        panel.classList.add('is-open');
        toggleBtn.setAttribute('aria-expanded', 'true');
        window.setTimeout(function () {
          input.focus();
        }, 50);
      }

      function closePanel() {
        panel.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
        hideResults();
      }

      toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (panel.classList.contains('is-open')) {
          closePanel();
        } else {
          openPanel();
        }
      });

      document.addEventListener('click', function (e) {
        if (!panel.contains(e.target) && e.target !== toggleBtn) {
          closePanel();
        }
      });
    } else {
      document.addEventListener('click', function (e) {
        if (!form.parentElement.contains(e.target)) {
          hideResults();
        }
      });
    }
  }

  setupSearchWidget({
    form: document.querySelector('[data-new-header-desktop-search-form]'),
    input: document.querySelector('[data-new-header-desktop-search-input]'),
    clearBtn: document.querySelector('[data-new-header-desktop-search-clear]'),
    resultsBox: document.querySelector('[data-new-header-desktop-search-results]')
  });

  setupSearchWidget({
    form: document.querySelector('[data-new-header-mobile-search-form]'),
    input: document.querySelector('[data-new-header-mobile-search-input]'),
    clearBtn: document.querySelector('[data-new-header-mobile-search-clear]'),
    resultsBox: document.querySelector('[data-new-header-mobile-search-results]'),
    toggleBtn: document.querySelector('[data-new-header-mobile-search-toggle]'),
    panel: document.querySelector('[data-new-header-mobile-search]')
  });
});


const menu = document.querySelector('.menuu');

window.addEventListener('scroll', () => {
  if (window.scrollY > 0) {
    menu.classList.add('scrolled');
  } else {
    menu.classList.remove('scrolled');
  }
});
const mobhead = document.querySelector('.new-header-mobile');

window.addEventListener('scroll', () => {
  if (window.scrollY > 0) {
    mobhead.classList.add('scrolled');
  } else {
    mobhead.classList.remove('scrolled');
  }
});


/* ------------------------------------------------------------------ */
/* CART DRAWER — manual open only (click cart icon to open/close).    */
/* Add-to-cart keeps updating the count via the script already in the */
/* liquid file — this only controls when the real drawer opens.      */
/* ------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', function () {
  var headerCartEl = document.getElementById('HeaderCart');
  var cartTriggers = document.querySelectorAll('.new-header-cart, .new-header-mobile__cart');

  if (typeof theme === 'undefined' || !theme.HeaderCart || !headerCartEl) return;

  var cartInstance = new theme.HeaderCart();

  // Block the theme's own auto-open-after-add-to-cart behavior.
  // Only opens when our own cart icon click sets _allowOpen first.
  var themeCartOpen = theme.HeaderCart.prototype.open;
  cartInstance.open = function (evt) {
    if (cartInstance._allowOpen) {
      cartInstance._allowOpen = false;
      themeCartOpen.call(cartInstance, evt);
    }
  };

  cartTriggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault(); // don't navigate to /cart
      if (headerCartEl.classList.contains('is-active')) {
        cartInstance.close();
      } else {
        cartInstance._allowOpen = true;
        cartInstance.open();
      }
    });
  });
});


// // {%- comment -%}
// //   ============ CART COUNT LIVE UPDATE ============
// //   Keeps data-new-header-cart-count in sync with the real cart without
// //   a page refresh. Works regardless of which add-to-cart script the
// //   theme uses, because it intercepts any network request going to
// //   Shopify's cart endpoints (/cart/add, /cart/change, /cart/update,
// //   /cart/clear) rather than depending on a specific theme event name.
// // {%- endcomment -%}

// (function () {
//   if (window.__newHeaderCartWatcherInit) return;
//   window.__newHeaderCartWatcherInit = true;

//   function updateNewHeaderCartCount(count) {
//     document.querySelectorAll('[data-new-header-cart-count]').forEach(function (el) {
//       el.textContent = count;
//     });
//   }

//   function refreshNewHeaderCartCount() {
//     fetch('/cart.js', { credentials: 'same-origin' })
//       .then(function (res) { return res.json(); })
//       .then(function (cart) { updateNewHeaderCartCount(cart.item_count); })
//       .catch(function () {});
//   }

//   function isCartEndpoint(url) {
//     if (!url) return false;
//     url = url.toString();
//     return /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
//   }

//   // Specifically /cart/add (not change/update/clear) — this is what
//   // should trigger the "Added to Cart" badge, on ANY page including
//   // search results.
//   function isAddToCartEndpoint(url) {
//     if (!url) return false;
//     url = url.toString();
//     return /\/cart\/add(\.js)?(\?|$)/.test(url);
//   }

//   var newHeaderBadgeTimer = null;
//   function showAddedToCartBadge() {
//     var badge = document.getElementById('new-header-added-badge');
//     if (!badge) return;
//     badge.classList.add('is-visible');
//     clearTimeout(newHeaderBadgeTimer);
//     newHeaderBadgeTimer = setTimeout(function () {
//       badge.classList.remove('is-visible');
//     }, 2200);
//   }

//   // Catch fetch()-based add-to-cart (most modern themes/apps)
//   var origFetch = window.fetch;
//   window.fetch = function () {
//     var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
//     var result = origFetch.apply(this, arguments);
//     if (isCartEndpoint(url)) {
//       result.then(function (res) {
//         refreshNewHeaderCartCount();
//         if (isAddToCartEndpoint(url) && res && res.ok) {
//           showAddedToCartBadge();
//         }
//       }).catch(function () {});
//     }
//     return result;
//   };

//   // Catch XMLHttpRequest-based add-to-cart (older themes/apps)
//   var origOpen = XMLHttpRequest.prototype.open;
//   XMLHttpRequest.prototype.open = function (method, url) {
//     this.__isNewHeaderCartCall = isCartEndpoint(url);
//     this.__isNewHeaderAddCall = isAddToCartEndpoint(url);
//     return origOpen.apply(this, arguments);
//   };
//   var origSend = XMLHttpRequest.prototype.send;
//   XMLHttpRequest.prototype.send = function () {
//     if (this.__isNewHeaderCartCall) {
//       var xhr = this;
//       this.addEventListener('loadend', function () {
//         refreshNewHeaderCartCount();
//         if (xhr.__isNewHeaderAddCall && xhr.status >= 200 && xhr.status < 300) {
//           showAddedToCartBadge();
//         }
//       });
//     }
//     return origSend.apply(this, arguments);
//   };

//   // Plain (non-AJAX) form submits to /cart/add — safety net
//   document.addEventListener('submit', function (e) {
//     var form = e.target;
//     if (form && form.action && isCartEndpoint(form.action)) {
//       setTimeout(refreshNewHeaderCartCount, 300);
//       if (isAddToCartEndpoint(form.action)) {
//         showAddedToCartBadge();
//       }
//     }
//   });

//   // Bonus: also listen for common custom events some themes/apps
//   // dispatch — harmless if these never fire on your theme
//   ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart:updated', 'cart:change']
//     .forEach(function (evt) {
//       document.addEventListener(evt, refreshNewHeaderCartCount);
//     });

//   // Initial sync on page load
//   refreshNewHeaderCartCount();
// })();